import React from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import { connect } from "react-redux"

// Actions
import { setWarningMessage } from "Containers/Messages/actions"

// Style
import {
  ButtonHistory,
  Link,
  IconContainer,
} from "Components/chartsLibrary/RedirectButton/index.style"

const RedirectButton = ({
  onSetWarningMessage,
  redirectButtonBackgroundColor,
  redirectButtonIconAlignement,
  redirectButtonBorderActive,
  redirectButtonBorderColor,
  redirectButtonBorderStyle,
  redirectButtonBorderSize,
  redirectButtonSelectIcon,
  redirectButtonReferentiel,
  redirectButtonIsReferentiel,
  redirectButtonIsPageUrl,
  redirectButtonPageUrl,
  redirectButtonIsUrl,
  redirectButtonUrl,
  widgetTraduction,
  fontAlignement,
  activeRadius,
  borderRadius,
  labelWeight,
  labelColor,
  labelSize,
  label,
  configMode,
  isAWidgetFromSettings,
}) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (redirectButtonIsPageUrl) {
      if (redirectButtonPageUrl === "") {
        onSetWarningMessage({
          message: widgetTraduction?.NO_PAGE,
        })
      } else {
        navigate(`/page/${redirectButtonPageUrl}`)
      }
    } else if (redirectButtonIsReferentiel) {
      if (redirectButtonReferentiel === "") {
        onSetWarningMessage({
          message: widgetTraduction?.NO_PAGE,
        })
      } else {
        navigate(`/referentials/${redirectButtonReferentiel}`)
      }
    }
  }
  // Check http/https de l'URL de redirection
  const checkUrl = redirectButtonUrl.includes("http")
  const redirectButtonUrlChecked = checkUrl ? redirectButtonUrl : `https://${redirectButtonUrl}`
  const checkModeConfig = configMode || isAWidgetFromSettings

  return redirectButtonIsPageUrl || redirectButtonIsReferentiel ? (
    <ButtonHistory
      onClick={!checkModeConfig && handleClick}
      backgroundColor={redirectButtonBackgroundColor}
      borderColor={redirectButtonBorderColor}
      borderStyle={redirectButtonBorderStyle}
      borderSize={redirectButtonBorderSize}
      isActive={redirectButtonBorderActive}
      fontAlignement={fontAlignement}
      activeRadius={activeRadius}
      borderRadius={borderRadius}
      labelWeight={labelWeight}
      labelColor={labelColor}
      labelSize={labelSize}
    >
      {redirectButtonIconAlignement === "left" && redirectButtonSelectIcon !== "" && (
        <IconContainer label={label} iconAlignement={redirectButtonIconAlignement}>
          <i className={redirectButtonSelectIcon} />
        </IconContainer>
      )}
      {label}
      {redirectButtonIconAlignement === "right" && redirectButtonSelectIcon !== "" && (
        <IconContainer label={label} iconAlignement={redirectButtonIconAlignement}>
          <i className={redirectButtonSelectIcon} />
        </IconContainer>
      )}
    </ButtonHistory>
  ) : redirectButtonUrl === "" ? (
    <ButtonHistory
      onClick={() =>
        onSetWarningMessage({
          message: widgetTraduction?.NO_URL,
        })
      }
      backgroundColor={redirectButtonBackgroundColor}
      borderColor={redirectButtonBorderColor}
      borderStyle={redirectButtonBorderStyle}
      borderSize={redirectButtonBorderSize}
      isActive={redirectButtonBorderActive}
      fontAlignement={fontAlignement}
      activeRadius={activeRadius}
      borderRadius={borderRadius}
      labelWeight={labelWeight}
      labelColor={labelColor}
      labelSize={labelSize}
    >
      {redirectButtonIconAlignement === "left" && redirectButtonSelectIcon !== "" && (
        <IconContainer label={label} iconAlignement={redirectButtonIconAlignement}>
          <i className={redirectButtonSelectIcon} />
        </IconContainer>
      )}
      {label}
      {redirectButtonIconAlignement === "right" && redirectButtonSelectIcon !== "" && (
        <IconContainer label={label} iconAlignement={redirectButtonIconAlignement}>
          <i className={redirectButtonSelectIcon} />
        </IconContainer>
      )}
    </ButtonHistory>
  ) : (
    <Link
      backgroundColor={redirectButtonBackgroundColor}
      borderColor={redirectButtonBorderColor}
      borderStyle={redirectButtonBorderStyle}
      borderSize={redirectButtonBorderSize}
      isActive={redirectButtonBorderActive}
      fontAlignement={fontAlignement}
      activeRadius={activeRadius}
      borderRadius={borderRadius}
      labelWeight={labelWeight}
      labelColor={labelColor}
      labelSize={labelSize}
      href={!checkModeConfig && redirectButtonUrlChecked}
      target="_blank"
    >
      {redirectButtonIconAlignement === "left" && redirectButtonSelectIcon !== "" && (
        <IconContainer label={label} iconAlignement={redirectButtonIconAlignement}>
          <i className={redirectButtonSelectIcon} />
        </IconContainer>
      )}
      {label}
      {redirectButtonIconAlignement === "right" && redirectButtonSelectIcon !== "" && (
        <IconContainer label={label} iconAlignement={redirectButtonIconAlignement}>
          <i className={redirectButtonSelectIcon} />
        </IconContainer>
      )}
    </Link>
  )
}

RedirectButton.propTypes = {
  onSetWarningMessage: PropTypes.func,
  redirectButtonBackgroundColor: PropTypes.string,
  redirectButtonIconAlignement: PropTypes.string,
  redirectButtonBorderActive: PropTypes.bool,
  redirectButtonBorderColor: PropTypes.string,
  redirectButtonBorderStyle: PropTypes.string,
  redirectButtonBorderSize: PropTypes.string,
  redirectButtonSelectIcon: PropTypes.string,
  redirectButtonIsPageUrl: PropTypes.bool,
  redirectButtonPageUrl: PropTypes.string,
  redirectButtonReferentiel: PropTypes.string,
  redirectButtonIsReferentiel: PropTypes.bool,
  redirectButtonIsUrl: PropTypes.bool,
  redirectButtonUrl: PropTypes.string,
  activeRadius: PropTypes.bool,
  borderRadius: PropTypes.string,
  labelWeight: PropTypes.string,
  labelColor: PropTypes.string,
  labelSize: PropTypes.string,
  label: PropTypes.string,
  configMode: PropTypes.bool,
  isAWidgetFromSettings: PropTypes.bool,
}

RedirectButton.defaultProps = {
  onSetWarningMessage: () => {},
  redirectButtonBackgroundColor: "#FFFFFF",
  redirectButtonIconAlignement: "right",
  redirectButtonBorderActive: false,
  redirectButtonBorderColor: "#000",
  redirectButtonBorderStyle: "solid",
  redirectButtonBorderSize: "1px",
  redirectButtonSelectIcon: "",
  redirectButtonIsPageUrl: false,
  redirectButtonPageUrl: "",
  redirectButtonReferentiel: "",
  redirectButtonIsReferentiel: false,
  redirectButtonIsUrl: true,
  redirectButtonUrl: "",
  activeRadius: false,
  borderRadius: "5px",
  labelWeight: "bold",
  labelColor: "#000000",
  labelSize: "1.2rem",
  label: "ACTION",
  configMode: false,
  isAWidgetFromSettings: false,
}

const mapDispatchToProps = dispatch => ({
  onSetWarningMessage: core => dispatch(setWarningMessage(core)),
})

export default connect(null, mapDispatchToProps)(RedirectButton)
